import React from 'react';
import { Navigate, useNavigate } from 'react-router';
import { useApptekster } from '../../contexts/ApptekstContext';
import { HotjarMaskert } from '../../components/HotjarMaskert';
import { Paragraph } from '../../components/Paragraph';
import { useSoknadStatusState } from './Soknad';
import { SVVLayoutBanner } from '@komponentkassen/svv-layout';
import { SVVInformationMessage } from '@komponentkassen/svv-information-message';
import { SVVButton } from '@komponentkassen/svv-button';

export const SoknadBekreftelse: React.FC = () => {
    const t = useApptekster();
    const navigate = useNavigate();
    const soknadStatus = useSoknadStatusState((state) => state.soknadStatus);

    if (!soknadStatus) {
        return <Navigate to="/" />;
    }

    return (
        <>
            <SVVLayoutBanner>
                <h1 className="spacing-bottom--medium">
                    {t('personlig-kjennemerke.soknad.overskrift')}
                </h1>
                <SVVInformationMessage
                    type="success"
                    className="spacing-bottom--medium"
                >
                    {t('personlig-kjennemerke.soknad.bekreftelse.ingress')}:{' '}
                    <strong className="bold">
                        <HotjarMaskert>
                            {soknadStatus?.tegnkombinasjon}
                        </HotjarMaskert>
                    </strong>
                </SVVInformationMessage>

                <Paragraph className="spacing-bottom--xxsmall">
                    <strong>
                        {t('personlig-kjennemerke.soknad.bekreftelse.dato')}:
                    </strong>{' '}
                    <HotjarMaskert>{soknadStatus?.dato}</HotjarMaskert>
                </Paragraph>

                <Paragraph>
                    {t(
                        'personlig-kjennemerke.soknad.bekreftelse.behandlingstid',
                    )}
                    : <strong>4 {t('personlig-kjennemerke.delt.uker')}</strong>.{' '}
                    {t('personlig-kjennemerke.soknad.bekreftelse.soknad-svar')}
                </Paragraph>
                <SVVButton onClick={() => navigate('/statusoversikt')}>
                    {t('personlig-kjennemerke.soknad.bekreftelse.se-status')}
                </SVVButton>
            </SVVLayoutBanner>
            <SVVLayoutBanner secondary>
                <h2 className="spacing-bottom--xxsmall">
                    {t(
                        'personlig-kjennemerke.soknad.bekreftelse.hva-skjer-videre',
                    )}
                </h2>
                <ul className="spacing-bottom--small">
                    <li className="p">
                        {t(
                            'personlig-kjennemerke.soknad.bekreftelse.hva-skjer-videre.betale',
                        )}
                    </li>
                    <li className="p">
                        {t(
                            'personlig-kjennemerke.soknad.bekreftelse.hva-skjer-videre.bestille',
                        )}
                    </li>
                    <li className="p">
                        {t(
                            'personlig-kjennemerke.soknad.bekreftelse.hva-skjer-videre.hente',
                        )}
                    </li>
                    <li className="p">
                        {t(
                            'personlig-kjennemerke.soknad.bekreftelse.hva-skjer-videre.knytte',
                        )}
                    </li>
                </ul>
                <p>
                    {t(
                        'personlig-kjennemerke.soknad.bekreftelse.hva-skjer-videre.status',
                    )}
                </p>
            </SVVLayoutBanner>
        </>
    );
};
